import { useForm, useFormState } from 'react-final-form';
import { type FactorialParamsResponse, type FactorialLeave } from 'src/shared/api/integrations/factorial';

export const SELECT_ALL_VALUE = 'all';

const mapFactorialLeavesToSelect = (data: FactorialLeave[]) =>
  data.map(el => ({ label: el.translated_name, value: el.translated_name.trim() }));

export const useStep4 = (data: FactorialParamsResponse | undefined) => {
  const form = useForm();
  const { values } = useFormState();
  const dataToSelect = mapFactorialLeavesToSelect(data?.leaves ?? []);
  const allSelected = values?.leaves?.length === dataToSelect.length;

  const handleManualChange = (event: React.ChangeEvent<{ value: string }>) => {
    const value = event.target.value;
    if (value[value.length - 1] === SELECT_ALL_VALUE) {
      form.change('leaves', allSelected ? [] : dataToSelect.map(({ value }) => value));
      return;
    }
    form.change('leaves', value);
  };

  return {
    handleChange: handleManualChange,
    dataToSelect,
    values
  };
};
